export const formatDate = (initDate: string) => {
    const localeDate = new Date(initDate).toLocaleDateString();
    const date = localeDate.split("T")[0].split("/");
    return `${date[0]}/${date[1]}/${date[2]}`;
};